(function($) {
    "use strict";
    $(function() {

        const lang = jQuery('html').attr('lang').substr(0, 2);

        // if ( window.location.href.indexOf("#wpcf7") > -1 && !$('.wpcf7-response-output').is(":visible")) {
        //     $('#successModal').modal('show');
        // }

        document.addEventListener( 'wpcf7mailsent', function( event ) {
            $('.wpcf7-not-valid').focusin(function(){
                $(this).parents('.form-group').find('.wpcf7-not-valid-tip').slideUp(100);
                $(this).removeClass('wpcf7-not-valid');
            });
            $('#successModal').modal('show');
        }, false );

        $(".wpcf7-form input[type=file]").on("change", function(e){
            if (lang == 'hu') {
                $(this).parents('.wpcf7-form').find('.btn.btn-primary-outline').html('Feltöltve');
            } else {
                $(this).parents('.wpcf7-form').find('.btn.btn-primary-outline').html('File uploaded');
            }
        });        
        
    });
})(jQuery);